// 好友关系表
import { DB, ExecuteResult } from "./index";
import time from "../time";

const upsert_sql =
    "insert into t_user_devices(" +
    "uid, devices, lutime, lctime" +
    ") values(" +
    "?, ?, ?, ?" +
    ") ON CONFLICT(uid) DO UPDATE SET " +
    "devices=?, lutime=?;";

export async function login_device_upsert(
    db: DB,
    uid: number,
    device: LoginDevice[]
): Promise<ExecuteResult> {
    const timeUNIX = time.toUnixMillSecond(time.now());
    const d = LoginDeviceToEntity(uid, device);
    d.lctime = timeUNIX;
    d.lutime = timeUNIX;
    const params = [];
    // INSERT
    params.push(...[d.uid, d.devices, d.lutime, d.lctime]);
    // UPDATE
    params.push(...[d.devices, d.lutime]);
    return await db.Execute(upsert_sql, params);
}

export async function queryLoginDevicesLocal(db: DB, uid: number): Promise<{ error: any; devices?: LoginDevice[] }> {
    const sql = `select * from t_user_devices where uid = ?`;
    const r = await db.Query(sql, [uid]);
    if (r.error) {
        return { error: r.error };
    }
    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }
    const d = r.data as LoginDevice[];
    return { error: null, devices: d };
}

function LoginDeviceToEntity(uid: number, a: LoginDevice[]): LoginDeviceEntity {
    const b: LoginDeviceEntity = {
        uid: uid,
        devices: JSON.stringify(a),
        lutime: Date.now(),
        lctime: Date.now()
    };
    return b;
}

export interface TenantSettings {
    switch_regist?: number //是否开启【注册】, 0 = 关闭, 1 = 开启
    switch_tab_main?: number //是否开启【导航栏 - 主页】, 0-不开启，1-开启
    switch_tab_mine?: number //是否开启【导航栏 - 我的】, 0-不开启，1-开启
    switch_rtc?: number //0 || 1 是否开启音视频功能，0-不开启，1-开启音视频功能
}

export interface LoginDevice {
    deviceId: string; // 设备id
    deviceModel: string //设备型号,
    deviceOS: string //操作系统,
    platform: string //平台,
    lastLoginTime: number; // 最后登录时间
}

type LoginDeviceEntity = {
    uid: number; // 朋友的uid
    devices: string; // 设备列表的JSON字符串
    lutime: number; // 本地 记录最后的修改时间
    lctime: number; // 本地 记录的创建时间
};
